// Test-id catalog. Source of truth lives in testIds.json — both this file and
// harness/testids_gen.go consume it, so adding a new selector means editing JSON
// only. The harness regenerates Go consts via scripts/gen-testids.mjs (auto-run
// before each `yarn workspace harness test`).
//
// Conventions:
// - `static`: fixed strings, one per testid. Add a new entry, then drop it onto
//   the component as `data-testid={TEST_IDS.yourKey}`.
// - `prefixes`: string prefixes for parameterized rows (per-slug, per-id). Use
//   the helper functions exported below — never concatenate by hand.
import raw from './testIds.json';
export const TEST_IDS = raw.static;
export const adminProductRow = (slug)=>`${raw.prefixes.adminProductRow}${slug}`;
export const adminOrderRow = (id)=>`${raw.prefixes.adminOrderRow}${id}`;
export const wholesalerRow = (email)=>`${raw.prefixes.wholesalerRow}${email}`;
export const pdpWholesaleTier = (minQty)=>`${raw.prefixes.pdpWholesaleTier}${minQty}`;
export const shopCatalogRow = (slug)=>`${raw.prefixes.shopCatalogRow}${slug}`;
